import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { HttpHeaders } from '@angular/common/http';
import { GuidesService } from 'src/app/api/tourism/guides.service';

@Component({
  selector: 'app-guides-form',
  templateUrl: './guides-form.component.html',
  styleUrls: ['./guides-form.component.css']
})
export class GuidesFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables =======
  typesdocument: any = [];
  partners: any = [];
  vehicletypes: any = [];
  statusmarital: any = [];
  sexs: any = [];
  // set values variables

  imageUrl: any = null;
  fileUrlImage: any = null;

  service_alert: any = {
    class: 'success',
    message: '',
    show: false
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private generalService: GeneralService,
    private globalService: GlobalService,
    private guideService: GuidesService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      document: [null, [Validators.required]],
      fullname: [null, [Validators.required, Validators.minLength(2)]],
      reference_name: [null],
      cellphone: [null],
      telephone: [null],
      email: [null, [Validators.email]],
      address: [null],
      date_birthday: [null],
      status: [null],
      sex: [null],
      url_image: [null],
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getStatusMarital();
    this.getSexs();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.guideService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          document: item_.document,
          fullname: item_.fullname,
          reference_name: item_.reference_name,
          cellphone: item_.cellphone,
          telephone: item_.telephone,
          email: item_.email,
          address: item_.email,
          date_birthday: item_.date_birthday,
          status: item_.status,
          sex: item_.sex,
          url_image: item_.url_image
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getStatusMarital() {
    this.generalService.listStatusMarital().subscribe({
      next: (data: any) => {
        this.statusmarital = data;
      }
    });
  }

  getSexs() {
    this.generalService.listSexs().subscribe({
      next: (data: any) => {
        this.sexs = data;
      }
    });
  }

  extractDni() {
    let param_ = this.item.value.document;
    if (!_.isEmpty(param_)) {
      this.generalService.extractDni(param_).subscribe({
        next: (data: any) => {
          if (data.success) {
            this.replaceExtractDataDni(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataDni(data: any) {
    this.item.patchValue({
      fullname: data.fullname,
      address: data.address
    });
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          if (data.success) {
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataRuc(data: any) {
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message =
      'El cliente se encuentra con estado ' +
      data.status +
      ' y en condición ' +
      data.condition;
    this.service_alert.show = true;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      formData.append('item', JSON.stringify(data));
      formData.append('url_image', this.fileUrlImage);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.guideService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.guideService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/guias/lista']);
  }
}
